// sort-imports-ignore

import 'unfonts.css'
import 'vuetify/styles'
import '#vue-shared-lib/styles/oura.scss'
import '@mdi/font/css/materialdesignicons.css'

import { createApp } from 'vue'

import { VueFire } from 'vuefire'

import { createPinia } from 'pinia'
import { PiniaColada } from '@pinia/colada'

import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

import { fetchAndActivate, setLogLevel, getRemoteConfig } from 'firebase/remote-config'

import App from '#ourahub-intra/App.vue'

import { createRouter } from '#ourahub-intra/router'

import { captureInitialPreset, captureInitialSearch, getAppPageTitle } from '#ourahub-intra/utilities'

import { ouraAliases, ouraDefaults } from '#vue-shared-lib/vuetify/OuraComponents'

import { createSentryPlugin } from '#vue-shared-lib/plugins/sentry'

import useOuraAuth from '#web-oura-tools/auth'
import useOuraTheme from '#web-oura-tools/theme'

import { ApiProviders } from '#web-oura-tools/types/auth'

document.title = getAppPageTitle()

// Read ?preset= and ?q= before auth may redirect, then strip them from the URL.
captureInitialPreset()
captureInitialSearch()

const defaults = {
  ...ouraDefaults,
  VMenu: { attach: '#outo-ourahub-intra' },
  VDialog: { attach: '#outo-ourahub-intra' },
  VTooltip: { attach: '#outo-ourahub-intra' },
  VSnackbar: { attach: '#outo-ourahub-intra' },
}

const vueApp = createApp(App)

const ouraAuth = useOuraAuth({ enableAutoLogin: true, apiProviders: [ApiProviders.OUTO_CLOUD] })

const vuePinia = createPinia()
const vueRouter = createRouter()

const ouraTheme = useOuraTheme()

const vueVuetify = createVuetify({
  aliases: ouraAliases,
  defaults,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    scope: '#outo-ourahub-intra',
    stylesheetId: 'outo-ourahub-intra-theme',
    defaultTheme: ouraTheme.getBrowserThemeMode(),
    themes: ouraTheme.getVuetifyThemes(import.meta.env.VITE_APP_CATEGORY),
  },
})

const vueSentryPlugin = createSentryPlugin({
  router: vueRouter,

  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_APP_VERSION,
  environment: import.meta.env.VITE_APP_ENV,
  tracingOrigin: import.meta.env.VITE_APP_URL,
})

vueApp.use(vuePinia)
vueApp.use(PiniaColada, {
  queryOptions: {
    staleTime: 0,
    refetchOnWindowFocus: false,
  },
})

vueApp.use(vueRouter)
vueApp.use(vueVuetify)

vueApp.use(vueSentryPlugin)

vueApp.use(VueFire, {
  firebaseApp: ouraAuth.firebaseApp.value,
})

const remoteConfig = getRemoteConfig(ouraAuth.firebaseApp.value)

remoteConfig.defaultConfig = {}

if (window.location.href.includes('debug')) {
  setLogLevel(remoteConfig, 'debug')

  remoteConfig.settings.minimumFetchIntervalMillis = 0
} else if (import.meta.env.VITE_APP_ENV !== 'release') {
  remoteConfig.settings.minimumFetchIntervalMillis = 60 * 1000
} else {
  remoteConfig.settings.minimumFetchIntervalMillis = 15 * 60 * 1000
}

fetchAndActivate(remoteConfig).then(() => {
  vueApp.mount('#outo-ourahub-intra')
})
